 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import TLU from '@/components/tlu'
 import MM from '@/components/mm'
 import ADD2019FRONTADD from '@/components/Add-2019/Front-add'
 import JACOBSON_LOSTCODEX_1P from '@/components/Jacobson_LostCodex_1P'
 import JACOBSON_LOSTCODEX_1P1 from '@/components/Jacobson_LostCodex_1P-1'
 import JACOBSON_LOSTCODEX_1P2 from '@/components/Jacobson_LostCodex_1P-2'
 import JACOBSON_LOSTCODEX_1P3 from '@/components/Jacobson_LostCodex_1P-3'
 import PART1 from '@/components/part1'
 import JACOBSON_LOSTCODEX_1P4 from '@/components/Jacobson_LostCodex_1P-4'
 import JACOBSON_LOSTCODEX_1P5 from '@/components/Jacobson_LostCodex_1P-5'
 import JACOBSON_LOSTCODEX_1P6 from '@/components/Jacobson_LostCodex_1P-6'
 import JACOBSON_LOSTCODEX_1P7 from '@/components/Jacobson_LostCodex_1P-7'
 import JACOBSON_LOSTCODEX_1P8 from '@/components/Jacobson_LostCodex_1P-8'
 import JACOBSON_LOSTCODEX_1P9 from '@/components/Jacobson_LostCodex_1P-9'
 import JACOBSON_LOSTCODEX_1P10 from '@/components/Jacobson_LostCodex_1P-10'
 import JACOBSON_LOSTCODEX_1P11 from '@/components/Jacobson_LostCodex_1P-11'
 import JACOBSON_LOSTCODEX_1P12 from '@/components/Jacobson_LostCodex_1P-12'
 import JACOBSON_LOSTCODEX_1P13 from '@/components/Jacobson_LostCodex_1P-13'
 import JACOBSON_LOSTCODEX_1P14 from '@/components/Jacobson_LostCodex_1P-14'
 import JACOBSON_LOSTCODEX_1P15 from '@/components/Jacobson_LostCodex_1P-15'
 import JACOBSON_LOSTCODEX_1P16 from '@/components/Jacobson_LostCodex_1P-16'
 import JACOBSON_LOSTCODEX_1P17 from '@/components/Jacobson_LostCodex_1P-17'
 import JACOBSON_LOSTCODEX_1P18 from '@/components/Jacobson_LostCodex_1P-18'
 import JACOBSON_LOSTCODEX_1P19 from '@/components/Jacobson_LostCodex_1P-19'
 import JACOBSON_LOSTCODEX_1P20 from '@/components/Jacobson_LostCodex_1P-20'
 import JACOBSON_LOSTCODEX_1P21 from '@/components/Jacobson_LostCodex_1P-21'
 import JACOBSON_LOSTCODEX_1P22 from '@/components/Jacobson_LostCodex_1P-22'
 import JACOBSON_LOSTCODEX_1P23 from '@/components/Jacobson_LostCodex_1P-23'
 import JACOBSON_LOSTCODEX_1P24 from '@/components/Jacobson_LostCodex_1P-24'
 import JACOBSON_LOSTCODEX_1P25 from '@/components/Jacobson_LostCodex_1P-25'
 import JACOBSON_LOSTCODEX_1P26 from '@/components/Jacobson_LostCodex_1P-26'
 import JACOBSON_LOSTCODEX_1P27 from '@/components/Jacobson_LostCodex_1P-27'
 import JACOBSON_LOSTCODEX_1P28 from '@/components/Jacobson_LostCodex_1P-28'
 import JACOBSON_LOSTCODEX_1P29 from '@/components/Jacobson_LostCodex_1P-29'
 import JACOBSON_LOSTCODEX_1P30 from '@/components/Jacobson_LostCodex_1P-30'
 import JACOBSON_LOSTCODEX_1P31 from '@/components/Jacobson_LostCodex_1P-31'
 import JACOBSON_LOSTCODEX_1P32 from '@/components/Jacobson_LostCodex_1P-32'
 import JACOBSON_LOSTCODEX_1P33 from '@/components/Jacobson_LostCodex_1P-33'
 import JACOBSON_LOSTCODEX_1P34 from '@/components/Jacobson_LostCodex_1P-34'
 import JACOBSON_LOSTCODEX_1P35 from '@/components/Jacobson_LostCodex_1P-35'
 import JACOBSON_LOSTCODEX_1P36 from '@/components/Jacobson_LostCodex_1P-36'
 import JACOBSON_LOSTCODEX_1P37 from '@/components/Jacobson_LostCodex_1P-37'
 import JACOBSON_LOSTCODEX_1P38 from '@/components/Jacobson_LostCodex_1P-38'
 import JACOBSON_LOSTCODEX_1P39 from '@/components/Jacobson_LostCodex_1P-39'
 import JACOBSON_LOSTCODEX_1P40 from '@/components/Jacobson_LostCodex_1P-40'
 import PART2 from '@/components/part2'
 import JACOBSON_LOSTCODEX_1P41 from '@/components/Jacobson_LostCodex_1P-41'
 import JACOBSON_LOSTCODEX_1P42 from '@/components/Jacobson_LostCodex_1P-42'
 import JACOBSON_LOSTCODEX_1P43 from '@/components/Jacobson_LostCodex_1P-43'
 import JACOBSON_LOSTCODEX_1P44 from '@/components/Jacobson_LostCodex_1P-44'
 import JACOBSON_LOSTCODEX_1P45 from '@/components/Jacobson_LostCodex_1P-45'
 import JACOBSON_LOSTCODEX_1P46 from '@/components/Jacobson_LostCodex_1P-46'
 import JACOBSON_LOSTCODEX_1P47 from '@/components/Jacobson_LostCodex_1P-47'
 import JACOBSON_LOSTCODEX_1P48 from '@/components/Jacobson_LostCodex_1P-48'
 import JACOBSON_LOSTCODEX_1P49 from '@/components/Jacobson_LostCodex_1P-49'
 import JACOBSON_LOSTCODEX_1P50 from '@/components/Jacobson_LostCodex_1P-50'
 import JACOBSON_LOSTCODEX_1P51 from '@/components/Jacobson_LostCodex_1P-51'
 import JACOBSON_LOSTCODEX_1P52 from '@/components/Jacobson_LostCodex_1P-52'
 import JACOBSON_LOSTCODEX_1P53 from '@/components/Jacobson_LostCodex_1P-53'
 import JACOBSON_LOSTCODEX_1P54 from '@/components/Jacobson_LostCodex_1P-54'
 import JACOBSON_LOSTCODEX_1P55 from '@/components/Jacobson_LostCodex_1P-55'
 import JACOBSON_LOSTCODEX_1P56 from '@/components/Jacobson_LostCodex_1P-56'
 import JACOBSON_LOSTCODEX_1P57 from '@/components/Jacobson_LostCodex_1P-57'
 import JACOBSON_LOSTCODEX_1P58 from '@/components/Jacobson_LostCodex_1P-58'
 import JACOBSON_LOSTCODEX_1P59 from '@/components/Jacobson_LostCodex_1P-59'
 import JACOBSON_LOSTCODEX_1P60 from '@/components/Jacobson_LostCodex_1P-60'
 import JACOBSON_LOSTCODEX_1P61 from '@/components/Jacobson_LostCodex_1P-61'
 import JACOBSON_LOSTCODEX_1P62 from '@/components/Jacobson_LostCodex_1P-62'
 import JACOBSON_LOSTCODEX_1P63 from '@/components/Jacobson_LostCodex_1P-63'
 import PART3 from '@/components/part3'
 import JACOBSON_LOSTCODEX_1P64 from '@/components/Jacobson_LostCodex_1P-64'
 import JACOBSON_LOSTCODEX_1P65 from '@/components/Jacobson_LostCodex_1P-65'
 import JACOBSON_LOSTCODEX_1P66 from '@/components/Jacobson_LostCodex_1P-66'
 import JACOBSON_LOSTCODEX_1P67 from '@/components/Jacobson_LostCodex_1P-67'
 import JACOBSON_LOSTCODEX_1P68 from '@/components/Jacobson_LostCodex_1P-68'
 import JACOBSON_LOSTCODEX_1P69 from '@/components/Jacobson_LostCodex_1P-69'
 import JACOBSON_LOSTCODEX_1P70 from '@/components/Jacobson_LostCodex_1P-70'
 import JACOBSON_LOSTCODEX_1P71 from '@/components/Jacobson_LostCodex_1P-71'
 import JACOBSON_LOSTCODEX_1P72 from '@/components/Jacobson_LostCodex_1P-72'
 import JACOBSON_LOSTCODEX_1P73 from '@/components/Jacobson_LostCodex_1P-73'
 import JACOBSON_LOSTCODEX_1P74 from '@/components/Jacobson_LostCodex_1P-74'
 import JACOBSON_LOSTCODEX_1P75 from '@/components/Jacobson_LostCodex_1P-75'
 import JACOBSON_LOSTCODEX_1P76 from '@/components/Jacobson_LostCodex_1P-76'
 import JACOBSON_LOSTCODEX_1P77 from '@/components/Jacobson_LostCodex_1P-77'
 import JACOBSON_LOSTCODEX_1P78 from '@/components/Jacobson_LostCodex_1P-78'
 import JACOBSON_LOSTCODEX_1P79 from '@/components/Jacobson_LostCodex_1P-79'
 import JACOBSON_LOSTCODEX_1P80 from '@/components/Jacobson_LostCodex_1P-80'
 import JACOBSON_LOSTCODEX_1P81 from '@/components/Jacobson_LostCodex_1P-81'
 import LOVE_1 from '@/components/love_1'
 import PREVIEW from '@/components/preview'
 import PREVIEWCOVER from '@/components/previewcover'
 import JACOBSON_DARKSIDEOFTHEMOON_3P_MB7 from '@/components/Jacobson_DarkSideOfTheMoon_3P_MB-7'
 import JACOBSON_DARKSIDEOFTHEMOON_3P_MB8 from '@/components/Jacobson_DarkSideOfTheMoon_3P_MB-8'
 import JACOBSON_DARKSIDEOFTHEMOON_3P_MB9 from '@/components/Jacobson_DarkSideOfTheMoon_3P_MB-9'
 import JACOBSON_DARKSIDEOFTHEMOON_3P_MB10 from '@/components/Jacobson_DarkSideOfTheMoon_3P_MB-10'
 import JACOBSON_LOSTCODEX_1P82 from '@/components/Jacobson_LostCodex_1P-82'
 import JACOBSON_LOSTCODEX_1P83 from '@/components/Jacobson_LostCodex_1P-83'
 import JACOBSON_LOSTCODEX_1P84 from '@/components/Jacobson_LostCodex_1P-84'
 import COPY from '@/components/copy'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIM-ad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/tlu",
 			"name" : "tlu",
 			"component" : TLU
 		},
 		{
 			"path" : "/mm",
 			"name" : "mm",
 			"component" : MM
 		},
 		{
 			"path" : "/Add-2019/Front-add",
 			"name" : "Add-2019/Front-add",
 			"component" : ADD2019FRONTADD
 		},
 		{
 			"path" : "/Jacobson_LostCodex_1P",
 			"name" : "Jacobson_LostCodex_1P",
 			"component" : JACOBSON_LOSTCODEX_1P
 		},
 		{
 			"path" : "/Jacobson_LostCodex_1P-1",
 			"name" : "Jacobson_LostCodex_1P-1",
 			"component" : JACOBSON_LOSTCODEX_1P1
 		},
 		{
 			"path" : "/Jacobson_LostCodex_1P-2",
 			"name" : "Jacobson_LostCodex_1P-2",
 			"component" : JACOBSON_LOSTCODEX_1P2
 		},
 		{
 			"path" : "/Jacobson_LostCodex_1P-3",
 			"name" : "Jacobson_LostCodex_1P-3",
 			"component" : JACOBSON_LOSTCODEX_1P3
 		},
 		{
 			"path" : "/part1",
 			"name" : "part1",
 			"component" : PART1
 		},
 		{
 			"path" : "/Jacobson_LostCodex_1P-4",
 			"name" : "Jacobson_LostCodex_1P-4",
 			"component" : JACOBSON_LOSTCODEX_1P4
 		},
 		{
 			"path" : "/Jacobson_LostCodex_1P-5",
 			"name" : "Jacobson_LostCodex_1P-5",
 			"component" : JACOBSON_LOSTCODEX_1P5
 		},
 		{
 			"path" : "/Jacobson_LostCodex_1P-6",
 			"name" : "Jacobson_LostCodex_1P-6",
 			"component" : JACOBSON_LOSTCODEX_1P6
 		},
 		{
 			"path" : "/Jacobson_LostCodex_1P-7",
 			"name" : "Jacobson_LostCodex_1P-7",
 			"component" : JACOBSON_LOSTCODEX_1P7
 		},
 		{
 			"path" : "/Jacobson_LostCodex_1P-8",
 			"name" : "Jacobson_LostCodex_1P-8",
 			"component" : JACOBSON_LOSTCODEX_1P8
 		},
 		{
 			"path" : "/Jacobson_LostCodex_1P-9",
 			"name" : "Jacobson_LostCodex_1P-9",
 			"component" : JACOBSON_LOSTCODEX_1P9
 		},
 		{
 			"path" : "/Jacobson_LostCodex_1P-10",
 			"name" : "Jacobson_LostCodex_1P-10",
 			"component" : JACOBSON_LOSTCODEX_1P10
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js